module.exports = __webpack_public_path__ + "static/img/003.2472de8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/003.png
// module id = yIDw
// module chunks = 1